import React from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import Menubar from '../Shared/MenuBar/Menubar';
import './ContactME.css'
import ContactSystem from './ContactSystem';
import Footer from '../Shared/Footer/Footer';
import emailjs from 'emailjs-com';
const ContactME = () => {
    const sendEmail=(e)=> {
        e.preventDefault();
    
        emailjs.sendForm('my_portfolio', 'template_5wba76r', e.target, 'user_bIla0gHf75nXTKN9fxne0')
          .then((result) => {
              alert('Thanks for message me, as soon as possible i reply you')
          }, (error) => {
              alert('Sorry there is some problem to send message, please message me in md.shozon041@gmail.com')
          });
          e.target.reset();
      }
    return (
        <div>
            <Menubar />
            <Container className="my-5">

                <Row >
                    <Col className="pt-3" md={5} align="center">
                        <ContactSystem/>
                    </Col>
                    <Col md={7}>
                        <h2 align="center">Wanna Contact Me?</h2>
                        <div className="contact-form">
                            <h4 className="form-title">Submit your details</h4>
                            <Form onSubmit={sendEmail}>
                                <Form.Group controlId="formGroupName">
                                    <Form.Control type="text" placeholder="Enter Name" name="name"/>
                                </Form.Group>
                                <Form.Group controlId="formGroupEmail">
                                    <Form.Control type="email" placeholder="Enter email" name="email"/>
                                </Form.Group>

                                <Form.Group controlId="formGroupSubject">
                                    <Form.Control type="text" placeholder="Enter Subject" name="subject"/>
                                </Form.Group>
                                <Form.Group controlId="formGroupSubject">
                                    <Form.Control placeholder="Enter Message" as="textarea" rows={3} name="message"/>
                                </Form.Group>
                                <Button className='formSubmitButton' type="submit">Submit</Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
                <Footer/>
            </Container>
        </div>
    );
};

export default ContactME;